export default __webpack_public_path__ + "static/media/bridge-runner.163a69db.png";